import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const trustIndicators = [
    { icon: 'ri-map-pin-2-line', text: t('hero.trust1') },
    { icon: 'ri-translate-2', text: t('hero.trust2') },
    { icon: 'ri-links-line', text: t('hero.trust3') },
    { icon: 'ri-shake-hands-line', text: t('hero.trust4') },
  ];

  return (
    <section
      className="relative min-h-screen flex items-center"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/70cd36f31b00af9ccfbe7e9b6e620eff.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-gray-950/80 via-gray-900/60 to-gray-800/30"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 pt-28 pb-24 w-full">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-4 py-1.5 mb-8 backdrop-blur-sm">
            <div className="w-1.5 h-1.5 bg-blue-400 rounded-full"></div>
            <span className="text-white/80 text-xs font-medium tracking-wider uppercase">{t('hero.badge')}</span>
          </div>

          <h1 className="text-5xl lg:text-6xl font-bold text-white leading-tight mb-6" style={{ fontFamily: "'Inter', sans-serif" }}>
            {t('hero.title1')}<br />
            {t('hero.title2')}<br />
            <span className="text-blue-300">{t('hero.title3')}</span>
          </h1>

          <p className="text-lg text-white/75 leading-relaxed max-w-xl mb-4">
            {t('hero.desc1')}
          </p>
          <p className="text-base text-white/60 leading-relaxed max-w-xl mb-10">
            {t('hero.desc2')}
          </p>

          <div className="flex flex-wrap gap-4 mb-14">
            <button
              onClick={() => navigate('/contact')}
              className="whitespace-nowrap bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-4 rounded-full transition-all duration-200 text-sm cursor-pointer"
            >
              {t('hero.ctaPrimary')}
            </button>
            <button
              onClick={() => navigate('/services')}
              className="whitespace-nowrap bg-white/10 hover:bg-white/20 border border-white/40 text-white font-medium px-8 py-4 rounded-full transition-all duration-200 text-sm cursor-pointer backdrop-blur-sm"
            >
              {t('hero.ctaSecondary')}
            </button>
          </div>

          <div className="flex flex-wrap gap-x-7 gap-y-3">
            {trustIndicators.map((item) => (
              <div key={item.text} className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-blue-300 text-sm`}></i>
                </div>
                <span className="text-xs text-white/65 font-medium">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
